import profileOutlined from './ProfileOutlined.svg?url';

export const ProfileOutlinedIcon = () => {
	return <img src={profileOutlined} alt="Profile Outlined Icon" />;
};
